import React, { useCallback, useEffect, useRef, useState } from "react";
import { base_apis } from "../../../config/url";
import Button from "../../CommonFields/Button";
import { toastError, toastSuccess } from "../../../Utilities/toast";
import { scrimGetLeaderBoard, scrimGameWinners } from "../../../api/scrim.api";
import { useParams } from "react-router";
import ListLoader from "../../Common/ListLoader";
import { t } from "i18next";
import premiumicon from "../../../images/premium.png";
import moment from "moment";
const ManageLeaderboard = ({ scrimId, scrim ,setScrim}) => {
  const [data, setData] = useState([])
  const [rankArray, setRankArray] = useState([]);
  const [idArray, setIdArray] = useState([]);
  const [ranks, setRanks] = useState({});
  const [isSubmitted, setLeaderboardSubmitted] = useState(false);
  const [canUploadWinning, setWinnings] = useState(false);

  const onChangeHandler = (e, id) => {
    if (e === "" || e.toString().length < 4) {  
        const value = e !== "" ? parseInt(e, 10) : 0;  
        setRanks(prev => ({ ...prev, [id]: value }));
    }
};

  const handleSubmit = async () => {
    const winners = Object.entries(ranks).map(([key, rank]) => ({ _id: key, rank: `${rank}` }));
    var finalWinner = []
    var isValueValid=true;
    winners.forEach(element => {
      if(element.rank.trim() ==='0' || element.rank ===0){
        isValueValid=false;
      }
      var userId = data.find((element2) => element2?._id === element?._id)?.userId
      finalWinner.push({ _id: userId, rank: element?.rank })
    });
    const payload = {
      _id: scrimId,
      winners: finalWinner,
    };
    
    if(isValueValid===false){
      toastError("Please enter rank for all players");
      return
    }

    try {
      const response = await scrimGameWinners(payload);
      if(response?.success){
        scrim.status =response?.data?.status
        setScrim(scrim)
        setLeaderboardSubmitted(true)
        toastSuccess(response.data.msg);
        fetchLeaderBoard()
      }else{
        toastError(response.data.data[0].msg)
      }
      
      
    } catch (error) {
      toastError('Error updating winners.');
    }
  };

  const check = () => {
    const rankValues = Object.values(ranks);
    console.log("ranks",ranks)
    if (rankValues.length === 0) {
      return "Please enter at least one rank";
    }
    if(rankValues.length !== data?.length){
      return "Please enter rank for all players";
    }
    const uniqueItems = [...new Set(rankValues)];
    if (uniqueItems.length !== rankValues.length) {
      return "Please enter unique ranks";
    }
    // New validation for checking if ranks start with 1 and are sequential
    const sortedRanks = uniqueItems.sort((a, b) => a - b);
    for (let i = 0; i < sortedRanks.length; i++) {
      if (sortedRanks[i] !== i + 1) {
        return "Ranks should start from 1 and be consecutive with no gaps";
      }
    }
  };

  const handlerSubmit = () => {
    const error = check();
    if (error) {
      toastError(error);
    } else {
      handleSubmit();
    }
  };

  useEffect(() => {
    setLoading(true)
    fetchLeaderBoard();
    winningUploadManage();
  }, []);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(12);
  const [totalPages, setTotalPages] = useState(1);
  const fetchLeaderBoard = async () => {
    try {
      const response = await scrimGetLeaderBoard({ search: { scrimId }, pagination: { pageNo: currentPage, recordPerPage: recordPerPage, sortBy: "createdAt", sortDirection: "asc" } });
      if (response?.success && response?.data) {
        setData(response?.data)
        setTotalPages(response?.totalPages)
        setData(response.data);
        response.data?.forEach(element => {
          onChangeHandler(element?.rank, element?._id)
        });
      }
      setLoading(false)
    }
    catch (err) {
      setLoading(false)
      console.error("Failed to fetch leaderboard:", err);
    }
  }
  const winningUploadManage=()=>{
    var scrimDate = scrim.date;
    var scrimTime = scrim.time;
    const currentTime = moment();
    const newDate = moment(new Date(scrimDate)).format("y-MM-DD");
    const newTime = moment(new Date(scrimTime)).format("HH:mm:ss");
    const formate = "YYYY-MM-DD h:m A";
    var dateTime = moment(newDate + " " + newTime);
    const startTime = moment(moment(dateTime), formate);
    const SSEndTime = moment(moment(dateTime).add(15, "minutes"), formate);

    const WDStartTime = moment(moment(dateTime), formate);
    const WDEndTime = moment(moment(dateTime).add(scrim?.game.settings.winningsTime,"minutes"),formate);
    let WDTime = currentTime.isBetween(WDStartTime, WDEndTime);
    setWinnings(WDTime)

    console.log('Winnings')
    console.log('dateTime', moment(dateTime).format("y-MM-DD HH:mm:ss"))
    console.log('startTime', moment(WDStartTime).format("y-MM-DD HH:mm:ss"))
    console.log('SSEndTime', moment(WDEndTime).format("y-MM-DD HH:mm:ss"))
    // console.log('SSEndTime', WDTime)
    // setWinnings(true)

  }

  const can=()=>{
    if((scrim?.status === 'In Review' || scrim?.status==='In Progress' ) && scrim?.picture?.length > 0 && canUploadWinning && isSubmitted ===false){
      return true;
    } else{
      return false;
    }
  }
  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );
  return (
    <>
      <div className="manage-contest scroll-none">
        {!loading &&
          data && data.length > 0 ?
          <> <div className="header d-flex justify-content-between ">
            <div className="d-flex flex-column align-items-center">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_3342_6477)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.92437 0C6.65546 0 4.84033 1.73793 4.84033 3.72414C4.84033 5.71034 6.65546 7.44828 8.92437 7.44828C11.1933 7.44828 13.0084 5.71034 13.0084 3.72414C13.0084 1.73793 11.1933 0 8.92437 0ZM6.5042 3.72414C6.5042 2.48276 7.56302 1.48966 8.92437 1.48966C10.2857 1.48966 11.3445 2.48276 11.3445 3.72414C11.3445 4.96552 10.2857 5.95862 8.92437 5.95862C7.56302 5.95862 6.5042 4.96552 6.5042 3.72414Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.62185 9.0625C3.93277 9.0625 0 12.6625 0 17.0073C0 17.628 0.453781 18.1246 1.21008 18.1246H16.7899C16.7899 18.1246 18 17.628 18 17.0073C18 12.6625 14.2185 9.0625 9.37815 9.0625H8.62185ZM9.37815 10.5522C13.0084 10.5522 16.0336 13.1591 16.3361 16.5108H1.66387C1.96639 13.1591 4.9916 10.5522 8.62185 10.5522H9.37815Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3342_6477">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>{t("private_contest.user_name")}</span>
            </div>
            <div className="d-flex flex-column align-items-center col-2">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_3342_6483)">
                    <path
                      d="M11.1309 6.32422H6.91921C6.61837 6.32422 6.36768 6.55125 6.36768 6.84314V17.481C6.36768 17.7729 6.61837 17.9999 6.91921 17.9999H11.1309C11.4317 17.9999 11.6824 17.7729 11.6824 17.481V6.84314C11.6824 6.55125 11.4317 6.32422 11.1309 6.32422ZM10.5794 16.9621H7.4206V7.39449H10.5794V16.9621Z"
                      fill="white"
                    />
                    <path
                      d="M4.76323 9.50293H0.551532C0.250696 9.50293 0 9.72996 0 10.0218V17.4813C0 17.7732 0.250696 18.0002 0.551532 18.0002H4.81337C5.11421 18.0002 5.3649 17.7732 5.3649 17.4813V10.0218C5.3649 9.72996 5.11421 9.50293 4.81337 9.50293H4.76323ZM4.26184 16.9624H1.05292V10.5732H4.26184V16.9624Z"
                      fill="white"
                    />
                    <path
                      d="M17.4987 12.6484H13.2368C12.936 12.6484 12.6853 12.8755 12.6853 13.1674V17.4484C12.6853 17.7403 12.936 17.9674 13.2368 17.9674H17.4987C17.7995 17.9674 18.0502 17.7403 18.0502 17.4484V13.1674C18.0502 12.8755 17.7995 12.6484 17.4987 12.6484ZM16.9471 16.962H13.7382V13.7187H16.9471V16.962Z"
                      fill="white"
                    />
                    <path
                      d="M11.5321 1.81622C11.4819 1.62162 11.3315 1.49189 11.1309 1.45946L10.0279 1.2973L9.52649 0.291892C9.42621 0.0972973 9.27579 0 9.07524 0C8.87468 0 8.67412 0.0972973 8.62398 0.291892L8.12259 1.2973L7.01953 1.45946C7.01953 1.45946 6.66855 1.62162 6.61841 1.81622C6.56827 2.01081 6.61841 2.20541 6.76883 2.36757L7.57106 3.14595L7.3705 4.24865C7.3705 4.44324 7.3705 4.63784 7.57106 4.76757C7.72148 4.8973 7.92203 4.8973 8.12259 4.8L9.12538 4.28108L10.1282 4.8C10.1282 4.8 10.5293 4.86486 10.6797 4.76757C10.8301 4.63784 10.9304 4.44324 10.8803 4.24865L10.6797 3.14595L11.4819 2.36757C11.4819 2.36757 11.6825 2.01081 11.6323 1.81622H11.5321ZM9.62677 2.59459C9.62677 2.59459 9.42621 2.88649 9.47635 3.04865V3.37297L9.22565 3.21081C9.12538 3.17838 9.07524 3.14595 8.97496 3.14595C8.87468 3.14595 8.82454 3.14595 8.72426 3.21081L8.42343 3.37297V3.04865C8.5237 2.88649 8.42343 2.69189 8.32315 2.59459L8.07245 2.36757L8.42343 2.3027C8.42343 2.3027 8.72426 2.17297 8.82454 2.01081L8.97496 1.71892L9.12538 2.01081C9.12538 2.01081 9.32593 2.27027 9.52649 2.3027L9.87746 2.36757L9.62677 2.59459Z"
                      fill="white"
                    />
                    <path
                      d="M5.16439 4.99493C5.11425 4.80033 4.96383 4.6706 4.76327 4.63817L3.66021 4.47601L3.15881 3.4706C3.05854 3.27601 2.90812 3.17871 2.70756 3.17871C2.507 3.17871 2.30645 3.27601 2.25631 3.4706L1.75491 4.47601L0.65185 4.63817C0.65185 4.63817 0.300875 4.80033 0.250736 4.99493C0.200597 5.18952 0.250736 5.38412 0.401154 5.54628L1.20338 6.32466L1.00283 7.42736C1.00283 7.62195 1.00282 7.81655 1.20338 7.94628C1.3538 8.07601 1.55436 8.07601 1.75491 7.97871L2.7577 7.45979L3.76049 7.97871C3.76049 7.97871 4.1616 8.04358 4.31202 7.94628C4.46244 7.81655 4.56271 7.62195 4.51257 7.42736L4.31202 6.32466L5.11425 5.54628C5.11425 5.54628 5.3148 5.18952 5.26466 4.99493H5.16439ZM3.30923 5.74087C3.30923 5.74087 3.10867 6.03276 3.15881 6.19493V6.51925L2.90812 6.35709C2.80784 6.32466 2.7577 6.29222 2.65742 6.29222C2.55714 6.29222 2.507 6.29222 2.40672 6.35709L2.10589 6.51925V6.19493C2.20617 6.03276 2.10589 5.83817 2.00561 5.74087L1.75491 5.51385L2.10589 5.44898C2.10589 5.44898 2.40672 5.31925 2.507 5.15709L2.65742 4.8652L2.80784 5.15709C2.80784 5.15709 3.0084 5.41655 3.20895 5.44898L3.55993 5.51385L3.30923 5.74087Z"
                      fill="white"
                    />
                    <path
                      d="M17.8497 8.14043C17.7995 7.94584 17.6491 7.81611 17.4486 7.78368L16.3455 7.62152L15.8441 6.61611C15.7438 6.42152 15.5934 6.32422 15.3929 6.32422C15.1923 6.32422 14.9917 6.42152 14.9416 6.61611L14.4402 7.62152L13.3372 7.78368C13.3372 7.78368 12.9862 7.94584 12.936 8.14043C12.8859 8.33503 12.936 8.52962 13.0865 8.69179L13.8887 9.47016L13.6881 10.5729C13.6881 10.7675 13.6881 10.9621 13.8887 11.0918C14.0391 11.2215 14.2397 11.2215 14.4402 11.1242L15.443 10.6053L16.4458 11.1242C16.4458 11.1242 16.8469 11.1891 16.9973 11.0918C17.1477 10.9621 17.248 10.7675 17.1979 10.5729L16.9973 9.47016L17.7995 8.69179C17.7995 8.69179 18.0001 8.33503 17.95 8.14043H17.8497ZM15.9945 8.91881C15.9945 8.91881 15.794 9.21071 15.8441 9.37287V9.69719L15.5934 9.53503C15.4931 9.5026 15.443 9.47016 15.3427 9.47016C15.2424 9.47016 15.1923 9.47016 15.092 9.53503L14.7912 9.69719V9.37287C14.8915 9.21071 14.7912 9.01611 14.6909 8.91881L14.4402 8.69179L14.7912 8.62692C14.7912 8.62692 15.092 8.49719 15.1923 8.33503L15.3427 8.04314L15.4931 8.33503C15.4931 8.33503 15.6937 8.59449 15.8943 8.62692L16.2452 8.69179L15.9945 8.91881Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3342_6483">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>{t("private_contest.rank")}</span>
            </div>
          </div>
            <div className="manage-leaderboard scroll-none">
              {data?.length > 0 && data.map((ele, index) => (
                <div className="d-flex justify-content-between row-box align-items-center" key={ele._id} ref={data?.length === index + 1 ? lastPostElementRef : null}>
                  <div className="d-flex col-6 align-items-center">
                    {/* <div className="col-2 me-3">
                      <img className="icon-30" src={`${base_apis?.imageUrl}${ele?.levels?.featuredImage?.default}`} alt={ele?.gamerJiName} />
                    </div> */}
                    <div className="d-flex flex-column align-items-start col-8">
                    {/* <div className="d-flex justify-content-between align-items-center w-100"> */}
    <div className="d-flex align-items-center w-100">
        <span className="f-12 mb-0">
            {ele?.gamerJiName?.length > 15 ? (
                <marquee>{ele?.gamerJiName}</marquee>
            ) : (
                ele?.gamerJiName
            )}
        </span>
        {ele?.isPremium && (
            <img
                className="players-table-img"
                src={premiumicon}
                alt="Premium Icon"
                style={{ alignSelf: 'center' }} 
            />
        )}
    </div>
    {/* <span className="f-10 text-color mb-0">
    {ele?.usersInGameName?.length > 18 ? (
                <marquee  style={{ color: '#595969' }}  >{ele?.usersInGameName}</marquee>
            ) : (
              ele?.usersInGameName
            )}
      </span> */}
</div>

                  </div>
                  {
                    (can()) ?
                      <div className="col-3 input-box">
                        <input
                          type="number"
                          value={ranks[ele._id] || ''}
                          onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                          onChange={(e) => onChangeHandler(e.target.value, ele._id)}
                          placeholder=""
                          style={{ textAlign: "center" ,fontSize:"1rem" }}
                          min={1}
                          maxLength={3}
                          length={3}
                        />
                      </div> : <div className="col-2 text-center" style={{ padding: '0.5rem' }}>
                        <span>{ranks[ele._id] ===''?'-':ranks[ele._id]}</span>
                      </div>
                  }

                </div>
              ))}

            </div></> : !loading && <>  <div className='no-record-found-center-my-contestlist'><span className="text-center">{t('common.no_data_found')}</span></div></>}


        {loading && <div className={currentPage === 1 ? 'w-100 d-flex justify-content-center no-record-found-center' : 'w-100 d-flex justify-content-center'}> <ListLoader /></div>}

      </div>

      <div className="mt-4">
        {/* <div className="mb-4">
          <p className="text-center">are you sure you want to submit</p>
          <div className="scrim-btn ">
          <button className="cancel-now" >cancel</button>
          <button className="d-flex justify-content-around" onClick={handleSubmit}>
            sumit
           
          </button>
          </div>
        </div> */}

        {(can()) && <Button text={"submit"} onClick={handlerSubmit} />}


      </div>
    </>
  );
};

export default ManageLeaderboard;
